import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {PickedBlock} from "./models/IrradiationWidgetApi";

export default class IrradiationWidgetStateModule extends AbacoVuexModule {
    @State() pickedBlock!: PickedBlock
}
